document.addEventListener('DOMContentLoaded', function() {
    const variantSelects = document.querySelectorAll('.color-swatch input[type="radio"]');

    variantSelects.forEach(function(input) {
        input.addEventListener('change', function() {
            const cardWrapper = this.closest('.card-wrapper');
            if (!cardWrapper) {
                return;
            }
            const variantDataElement = cardWrapper.querySelector('script[type="application/json"]');
            if (!variantDataElement) {
                return;
            }
            const variantData = JSON.parse(variantDataElement.textContent);
            const selectedVariantData = variantData.find(variant => variant.option1 === this.value);
            if (!selectedVariantData) {
                return;
            }
            if (!selectedVariantData.featured_image) {
                return;
            }
            const newImageUrl = selectedVariantData.featured_image.src;
            const hoverImageElement = cardWrapper.querySelector('.card__media img:nth-child(2)');
            if (hoverImageElement && selectedVariantData.featured_image) {
                hoverImageElement.src = selectedVariantData.featured_image.src;
                hoverImageElement.srcset = selectedVariantData.featured_image.src;
            }

        });
    });
});
